import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { v4 as uuidV4 } from 'uuid';
import { PrivacyMember, PrivacyTeam } from '@shared/dialogs/private-asset-settings-dialog/privacy.model';
const colors = [
  '#00b2dd',
  '#ec008c',
  '#a23f97',
  '#f58220',
  '#ffdd00',
  '#69be2b',
  '#004b35',
  '#00a657',
  '#bfd857',
  '#00b5db',
  '#d0021b',
];

@Component({
  selector: 'miq-privacy-contact-card',
  templateUrl: './privacy-contact-card.component.html',
  styleUrls: ['./privacy-contact-card.component.scss'],
  standalone: false,
})
export class PrivacyContactCardComponent implements OnChanges {
  @Input()
  public user: PrivacyMember;
  @Input()
  public isOnMIQ: boolean;
  public color: string;
  @Input()
  public selected: boolean;
  @Input() public selectedContactComponent: boolean;
  @Input() isUserAllowed: boolean;
  @Input() selectedUsersTeams: Array<PrivacyMember | PrivacyTeam> = [];
  @Output()
  public change: EventEmitter<{ checked: boolean; user: PrivacyMember }> = new EventEmitter();

  constructor() {
    // Security: use uuidv4 as entropy source for random color index.
    const uuidHex = uuidV4().replace(/-/g, '').slice(0, 8);
    this.color = colors[((parseInt(uuidHex, 16) >>> 0) % 10) + 1];
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedUsersTeams && changes.selectedUsersTeams.currentValue) {
      const thisCompponentUser = changes.selectedUsersTeams.currentValue.find(
        item => item.user_id === this.user.user_id
      );
      this.selected = thisCompponentUser && thisCompponentUser.selected;
    }
  }

  onClick() {
    if (this.selectedContactComponent) {
      return;
    }
    this.selected = !this.selected;
    this.change.emit({ checked: this.selected, user: this.user });
  }

  removeContact() {
    this.selected = false;
    this.change.emit({ checked: this.selected, user: this.user });
  }
}
